export * from './extra-vereinbarung-delete-request.interface';
export * from './extra-vereinbarung-delete-response.interface';
export * from './extra-vereinbarung-delete.shapes';
